var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useContext } from 'react';
import Box from '@mui/material/Box';
import { generateChatName, generateNextMessage, getChatMessages, regenerateMessage } from '../api';
import ApiContext from '../contexts/apiContext';
import ChatContext from '../contexts/chatContext';
import isGeneratedChatName from '../helpers/isGeneratedChatName';
import MessageList from './MessageList';
import Input from './Input';
import ErrorDialog from './ErrorDialog';
var Chat = function () {
    var _a = useState([]), messages = _a[0], setMessages = _a[1];
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(), errorMessage = _c[0], setErrorMessage = _c[1];
    var apiBaseUrl = useContext(ApiContext).apiBaseUrl;
    var _d = useContext(ChatContext), chat = _d.chat, dispatch = _d.dispatch;
    if (!chat) {
        return _jsx(_Fragment, {});
    }
    useEffect(function () {
        setLoading(true);
        getChatMessages(apiBaseUrl, chat.id)
            .then(setMessages)
            .catch(function (err) {
            // eslint-disable-next-line no-console
            console.error(err);
            setErrorMessage("There's been an error fetching the messages for this chat, please check your connection and reload the page");
        })
            .finally(function () { return setLoading(false); });
    }, [chat]);
    var getLastMessage = function () { return messages[messages.length - 1]; };
    var isLastMessageAUserOne = function () { var _a; return ((_a = getLastMessage()) === null || _a === void 0 ? void 0 : _a.role) === 'user'; };
    var generateTransientMessageId = function () { return "".concat(chat.id, "_").concat(Date.now(), "_").concat(Math.floor(Math.random() * 1000)); };
    var send = function (messageContent) { return __awaiter(void 0, void 0, void 0, function () {
        var previousMessages, content, transientMessage, response, isFirstMessage, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!messageContent.trim() || isLastMessageAUserOne()) {
                        return [2 /*return*/];
                    }
                    setLoading(true);
                    previousMessages = messages;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    content = messageContent.trim();
                    transientMessage = {
                        content: content,
                        id: generateTransientMessageId(),
                        role: 'user'
                    };
                    setMessages(__spreadArray(__spreadArray([], previousMessages, true), [transientMessage], false));
                    return [4 /*yield*/, generateNextMessage(apiBaseUrl, chat.id, content)];
                case 2:
                    response = _a.sent();
                    setMessages(__spreadArray(__spreadArray([], previousMessages, true), response, true));
                    isFirstMessage = previousMessages.length === 0;
                    if (isFirstMessage && isGeneratedChatName(chat.name) && dispatch) {
                        generateChatName(apiBaseUrl, chat.id)
                            .then(function (newName) {
                            return dispatch({
                                state: {
                                    id: chat.id,
                                    name: newName
                                },
                                type: 'edit_chat_name'
                            });
                        })
                            .catch(function (err) {
                            // eslint-disable-next-line no-console
                            console.error(err);
                        });
                    }
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    // eslint-disable-next-line no-console
                    console.error(err_1);
                    setMessages(previousMessages);
                    setErrorMessage("There's been an error sending your message, please check your connection and try again");
                    throw err_1;
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var regenerate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var lastMessage, previousMessages, newMessages, replyMessage, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    lastMessage = getLastMessage();
                    if (!lastMessage || isLastMessageAUserOne()) {
                        return [2 /*return*/];
                    }
                    previousMessages = messages;
                    newMessages = messages.slice(0, messages.length - 1);
                    setMessages(newMessages);
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, regenerateMessage(apiBaseUrl, chat.id)];
                case 2:
                    replyMessage = _a.sent();
                    setMessages(__spreadArray(__spreadArray([], newMessages, true), [replyMessage], false));
                    return [3 /*break*/, 5];
                case 3:
                    err_2 = _a.sent();
                    // eslint-disable-next-line no-console
                    console.error(err_2);
                    setMessages(previousMessages);
                    setErrorMessage("There's been an error regenerating the message, please check your connection and try again");
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleErrorDialogClose = function () { return setErrorMessage(undefined); };
    return (_jsxs(Box, { display: "flex", flexDirection: "column", alignItems: "center", height: "100%", children: [_jsx(ErrorDialog, { message: errorMessage, onClose: handleErrorDialogClose }), _jsx(MessageList, { messages: messages, loading: loading, goToBottom: true }), _jsx(Box, { width: "100%", zIndex: 3, children: _jsx(Input, { regenerateMessageDisabled: messages.length === 0 || isLastMessageAUserOne(), sendMessageDisabled: isLastMessageAUserOne(), regenerateMessage: regenerate, sendMessage: send }) })] }));
};
export default Chat;
